import { useState } from 'react';
import { MdChevronRight } from 'react-icons/md';
import { Button, Checkbox, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, IconButton, Selection } from '@ds';
import { SCHEDULE_ORGAN_SELECT_LIST } from '@/constants/case/case.constants';
import { OrganType, OrganTypeWithoutKidney } from '@/api/apis/case';

// TMDXLP-14091: Kidneys hidden from Schedule shift organ picker below.
// To restore, swap SCHEDULE_ORGAN_SELECT_LIST -> ORGAN_SELECT_LIST and OrganTypeWithoutKidney -> OrganType.

type CSShiftOrgansSubDropdownProps = {
  title: string;
  allowedOrgans?: OrganType[];
  initialOrgans?: OrganType[];
  onApply: (organs: Set<OrganType>) => void;
};

export const CSShiftOrgansSubDropdown = ({
  title,
  allowedOrgans = [],
  initialOrgans = [],
  onApply,
}: CSShiftOrgansSubDropdownProps) => {
  const [organs, setOrgans] = useState<Set<OrganType>>(new Set(initialOrgans));
  const disabledOrgans = new Set(
    Object.values(OrganTypeWithoutKidney).filter((organ) => !allowedOrgans?.includes(organ)),
  );

  const onSelectionChange = (keys: Selection) => {
    setOrgans(keys === 'all' ? new Set(Object.values(OrganTypeWithoutKidney)) : (keys as Set<OrganType>));
  };

  const onSelectionConfirm = () => {
    if (organs.size > 0) onApply(organs);
  };

  return (
    <div className="flex items-center justify-between max-h-[16.8px]">
      <div>{title}</div>
      <Dropdown placement="right" closeOnSelect={false} className="min-w-[140px]">
        <DropdownTrigger>
          <IconButton size="xs" variant="light" startContent={<MdChevronRight />} />
        </DropdownTrigger>
        <DropdownMenu
          aria-label="Select Organs"
          items={SCHEDULE_ORGAN_SELECT_LIST}
          hideSelectedIcon
          selectionMode="multiple"
          selectedKeys={organs}
          disabledKeys={disabledOrgans}
          onSelectionChange={onSelectionChange}
          bottomContent={
            <Button size="sm" variant="solid" className="mt-1" isDisabled={!organs.size} onPress={onSelectionConfirm}>
              Confirm
            </Button>
          }
        >
          {(organItem) => (
            <DropdownItem key={organItem.value} className="p-0" textValue={organItem.name}>
              <Checkbox readOnly className="pointer-events-none" checked={organs.has(organItem.value)}>
                {organItem.name}
              </Checkbox>
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
